// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.03130964c1db4346612e283a5cba9d13214632fc.js";
};